<template>
  <b-navbar toggleable="lg" type="light" variant="light" fixed="top" class="navbar-custom">
    <div class="container">
      <b-navbar-brand to="/">
        <span class="ml-2 font-weight-bold text-primary-custom">沈阳文盛化工有限公司</span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/" exact>首页</b-nav-item>
          <b-nav-item to="/products">产品中心</b-nav-item>
          <b-nav-item to="/about">关于我们</b-nav-item>
          <b-nav-item to="/contact">联系我们</b-nav-item>
        </b-navbar-nav>
        
        <b-navbar-nav class="ml-3">
          <b-nav-text class="text-primary font-weight-bold">
            <b-icon icon="telephone"></b-icon>
            13149833389
          </b-nav-text>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
.navbar-custom {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.navbar-brand {
  font-size: 1.5rem;
}

.nav-link {
  font-weight: 500;
  margin: 0 0.5rem;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #2c5aa0 !important;
}

.router-link-active {
  color: #2c5aa0 !important;
  font-weight: 600;
}
</style>